import { getYears } from '@/api/school/yearsApi';
import { createQueryHook } from '@/lib/adapters/react-query-adapter';
import { QueryKeys } from '@/lib/constants/query-keys';
import { type YearsResponse } from '@/schemas/years';

export const useYears = createQueryHook<YearsResponse, Error, [QueryKeys.YEARS]>([QueryKeys.YEARS], () => getYears());
